import React, { PropTypes, Component } from 'react';
import { Link } from 'react-router';

import Input from './Input';

export default class InfoForm extends Component {

	constructor(props){
		super(props);

		this.state = {
			message: 'this is a test message'
		};
	}

	render () {
		return (
			<div>
				<div>
					Need more student seats? Want to request a trial of other products? Let us know your situation
					below, and our team will quickly get back to you.
				</div>
				<div>
					contact us: <a href="mailto:info@colvardlearning.com">info@colvardlearning.com</a>
				</div>
			</div>);
	}
}




// WEBPACK FOOTER //
// ./js/components/InfoForm.js